"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helper_1 = require("./helper");
class ShoppingBasketCalculator {
    itemFilter;
    constructor(options) {
        this.itemFilter = options?.itemFilter
            ? options.itemFilter
            : (item) => {
                const webTemplateId = item.WebTemplateId || 1;
                return ![5, 9].includes(webTemplateId) && item.IsDiscounted !== true;
            };
    }
    /**
     * Calculates the Discount-Value taking into account Discount-Voucher-Items not being reducible, as well as the total
     * item price and the remaining DiscountVoucher value
     */
    calculate(items, discounts = []) {
        const sumPrice = (items) => {
            return (0, helper_1.sum)(...items.map((item) => {
                const quantity = item.Quantity || 1;
                return item.CurrentPrice * quantity;
            }));
        };
        // summed up price for all items
        const totalItemValue = sumPrice(items);
        const reducibleItems = items.filter((item) => this.itemFilter(item));
        const nonReducibleItems = items.filter((item) => !reducibleItems.includes(item));
        const reducibleItemsTotal = sumPrice(reducibleItems);
        const nonReducibleItemsTotal = sumPrice(nonReducibleItems);
        const sumDiscounts = (discounts) => {
            return (0, helper_1.sum)(...discounts.map((discount) => {
                if (discount.isPercentage)
                    return reducibleItemsTotal * (discount.value / 100);
                return discount.value;
            }));
        };
        const discountValue = sumDiscounts(discounts);
        const d = (0, helper_1.clamp)(discountValue, 0, reducibleItemsTotal);
        const t = totalItemValue - d;
        return {
            discount: d,
            total: (0, helper_1.clamp)(t, nonReducibleItemsTotal),
            remaining: reducibleItemsTotal ? discountValue - d : discountValue,
        };
    }
}
exports.default = ShoppingBasketCalculator;
